export function getApi() {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;
    
    console.log('当前hostname:', hostname);
    console.log('当前protocol:', protocol);
    console.log('当前port:', port);

    // 如果是本地开发
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        // 本地开发时，可以根据需要修改
        // return 'http://admin.xueli1.cn';
        return 'http://admin.xueli2.cc/';
    }

    // 解析域名
    const domainParts = hostname.split('.');
    console.log('域名分割结果:', domainParts);

    // 针对特定域名做特殊处理
    if (hostname === 'xuexinh5web.com') {
		console.log(66666)
        // 直接返回固定的admin域名
        const portStr = port ? `:${port}` : '';
        return `${protocol}//http://fastxuexin.com${portStr}`;
    }

    // 通用处理：确保是多级域名
    if (domainParts.length >= 3) {
        // 对于三级及以上域名，如 app.xueli1.cn
        domainParts[0] = 'admin';
    } else if (domainParts.length === 2) {
        // 对于二级域名，如 xueli1.cn
        domainParts.unshift('admin');
    } else {
        // 对于其他情况，直接添加admin前缀
        return `${protocol}//admin.${hostname}`;
    }

    const newHostname = domainParts.join('.');
    const portStr = port ? `:${port}` : '';
    
    console.log('生成的API地址:', `${protocol}//${newHostname}${portStr}`);
    return `${protocol}//${newHostname}${portStr}`;
}
getApi()